/* import __COLOCATED_TEMPLATE__ from './add-to-existing-content-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();